<template>
    <section class="">
        <div class="flex items-center justify-between max-w-screen-xl px-4 py-4 mx-auto">
            <div>
                <nuxt-img preload fetchpriority="high" loading="eager" width="128" height="91" class="relative z-20" :src="logoSrc" :alt="logoAlt" />
            </div>

            <div>
                <button @click="scrollTo(scrollTarget)"
                    class="items-center justify-center px-6 py-3.5 font-bold leading-4 text-center text-white hover:shadow-lg hover:opacity-80 font-ginger"
                    :style="{ background: primaryButtonColor }">
                    {{ buttonText }}</button>
            </div>
        </div>

        <div class="px-4 py-3" :style="{ background: backgroundColor }">
            <div
                class="flex flex-col items-center justify-between max-w-screen-xl px-4 mx-auto md:gap-y-0 gap-y-2 md:flex-row">
                <div class="text-white ">
                    <a :href="lifeboostLink" target="_blank"
                        class="pr-4 text-sm uppercase border-r border-white">{{ lifeboostText }}</a>
                    <span @click="scrollTo(scrollTarget)" class="pl-4 text-sm uppercase cursor-pointer">{{ productText }}</span>
                </div>

                <div class="text-sm text-white uppercase">
                    <span class="mr-4">{{ callUsText }}</span> <a :href="callUsLink">{{ phoneNumber }}</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    logoSrc: {
        type: String,
        default: "/assets/images/black-logo.svg"
    },
    logoAlt: {
        type: String,
        default: "Lifeboost Coffee Logo"
    },
    scrollTarget: {
        type: String,
        default: "the-products"
    },
    primaryButtonColor: {
        type: String,
        default: "#d20130"
    },
    buttonText: {
        type: String,
        default: "ADD TO CART"
    },
    backgroundColor: {
        type: String,
        default: "#d20130"
    },
    lifeboostLink: {
        type: String,
        default: "https://lifeboostcoffee.com/"
    },
    lifeboostText: {
        type: String,
        default: "lifeboost"
    },
    productText: {
        type: String,
        default: "frosted sugar cookie"
    },
    callUsText: {
        type: String,
        default: "CALL US TOLL FREE"
    },
    phoneNumber: {
        type: String,
        default: "1-800-479-1596"
    },
    callUsLink: {
        type: String,
        default: "tel:1-800-479-1596"
    }
});

defineBuilderComponent({
    friendlyName: "Header with CTA",
    inputs: [
        {
            name: "logoSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/black-logo.svg"
        },
        {
            name: "logoAlt",
            type: "text",
            defaultValue: "Lifeboost Coffee Logo"
        },
        {
            name: "scrollTarget",
            type: "text",
            defaultValue: "the-products"
        },
        {
            name: "primaryButtonColor",
            type: "color",
            defaultValue: "#d20130"
        },
        {
            name: "buttonText",
            type: "text",
            defaultValue: "ADD TO CART"
        },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: "#d20130"
        },
        {
            name: "lifeboostLink",
            type: "url",
            defaultValue: "https://lifeboostcoffee.com/"
        },
        {
            name: "lifeboostText",
            type: "text",
            defaultValue: "lifeboost"
        },
        {
            name: "productText",
            type: "text",
            defaultValue: "frosted sugar cookie"
        },
        {
            name: "callUsText",
            type: "text",
            defaultValue: "CALL US TOLL FREE"
        },
        {
            name: "phoneNumber",
            type: "text",
            defaultValue: "1-800-479-1596"
        },
        {
            name: "callUsLink",
            type: "url",
            defaultValue: "tel:1-800-479-1596"
        }
    ]
});
</script>
